





















import Vue from 'vue';
import { WebRequestStatus } from '../models';

export default Vue.extend({
  props: {
    status: {
      type: Number, // An enum
      default: -1
    },
    readyText: {
      type: String,
      default: 'Ready'
    },
    inProgressText: {
      type: String,
      default: 'In progress'
    },
    successText: {
      type: String,
      default: 'Finished!'
    },
    failureText: {
      type: String,
      default: 'Uh-oh, something went wrong :('
    }
  },

  computed: {
    isReady(): boolean {
      return this.status === -1 || this.status === WebRequestStatus.READY;
    },
    isInProgress(): boolean {
      return this.status === WebRequestStatus.IN_PROGRESS;
    },
    isFailure(): boolean {
      return this.status === WebRequestStatus.FAILURE;
    },
    isSuccess(): boolean {
      return this.status === WebRequestStatus.SUCCESS;
    }
  }
});
